module.exports = __webpack_public_path__ + "static/media/wor_clo_to_wat_saf_lin.c9378a22.png";